import React from 'react';
import mouseUtils from '../utils/MouseUtils';
import { changeContextMode } from '../../actions/MenuActions';
import modeType from '../../constants/ModeConstants';
import properties from '../../constants/Properties';
import appParameters from '../utils/AppParameters';
import locales from '../../locales/LocalesManager';
import { RotationView } from './RotationView';
import { PositionView } from './PositionView';
import { ResizeView } from './ResizeView';
import { FlipView } from './FlipView';
import { PrimaryMenuButton } from './SizeAndPositionButtons';
import platformDetection from '../utils/PlatformDetection';
import shapeConstants from '../../constants/ShapeConstants';
import {PositionViewLineAndCurve} from "./PositionViewLineAndCurve";

const SELECTED_VIEW_POSITION = 'selected_view_position';
const SELECTED_VIEW_ROTATION = 'selected_view_rotation';
const SELECTED_VIEW_SIZE = 'selected_view_size';
const SELECTED_VIEW_FLIP = 'selected_view_flip';

/*
TODO after uu:
- Reintroduce curve
- Reintroduce complex bubbles
    - Complex bubbles: Add support for speech bubble arrow position
    - Complex bubbles: Make flip horizontally work for figures and speech bubbles
- Add back slider for slide duration
- Add sliders to some of the new menu inputs (for instance opacity)
 */
export const SizeAndPositionMenu = React.createClass({
    getInitialState() {
        return {
            selectedViewType: SELECTED_VIEW_POSITION,
            key: 0
        };
    },
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            const element = document.getElementById('resizeFirstItem');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    onCloseClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    onClickButton(type) {
        this.setState({
            selectedViewType: type
        });
    },
    render() {
        const mainHolderSytle = {
          height: '100%',
          overflowX: 'hidden',
          overflowY: 'auto'
        };

        const titleStyle = {
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const caption = locales.getCaption('SizeAndPositionTitle', 'shapeMenu');

        const headingStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: '-6px'
        };

        const closeButtonStyle = {
            position: 'absolute',
            right: 28,
            top: 4,
            width: 22,
            height: 22,
            cursor: 'pointer',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            background: 'none',
            borderStyle: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 3,
            right: 3,
            cursor: 'pointer'
        };

        const wrapperStyle = {
            margin: '4%'
        };

        const buttonWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            justifyContent: 'space-between'
        };

        var isNonRectangular = (this.props.contextTarget.type == shapeConstants.LINE || this.props.contextTarget.type == shapeConstants.CURVE);
        var isComplexSpeechBubble = (this.props.contextTarget.type == shapeConstants.COMPLEX_SPEAK_BUBBLE);

        return (
            <div key={this.state.key}  id="sizeAndPositionMenu" style={mainHolderSytle}>
                <div style={titleStyle}>
                    <h2 style={headingStyle}>{caption}</h2>
                    <button id='resizeFirstItem' style={closeButtonStyle} aria-label={locales.getCaption('close', 'other')} onClick={this.onCloseClick} onTouchStart={this.onCloseClick}>
                        <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                    </button>
                </div>

                {isNonRectangular == false ?
                    <div style={wrapperStyle}>
                        <div style={buttonWrapperStyle}>
                            <PrimaryMenuButton clickHandler={this.onClickButton} type={SELECTED_VIEW_POSITION} isSelected={this.state.selectedViewType === SELECTED_VIEW_POSITION} caption={locales.getCaption('Position', 'sizePosMenu')}/>
                            <PrimaryMenuButton clickHandler={this.onClickButton} type={SELECTED_VIEW_ROTATION} isSelected={this.state.selectedViewType === SELECTED_VIEW_ROTATION} caption={locales.getCaption('Rotation', 'sizePosMenu')}/>
                            <PrimaryMenuButton clickHandler={this.onClickButton} type={SELECTED_VIEW_SIZE} isSelected={this.state.selectedViewType === SELECTED_VIEW_SIZE} caption={locales.getCaption('Size', 'sizePosMenu')}/>

                            {!isComplexSpeechBubble ?
                                <PrimaryMenuButton clickHandler={this.onClickButton} type={SELECTED_VIEW_FLIP} isSelected={this.state.selectedViewType === SELECTED_VIEW_FLIP} caption={locales.getCaption('Reflect', 'sizePosMenu')}/>
                                : null
                            }
                        </div>

                        {this.state.selectedViewType === SELECTED_VIEW_POSITION ?
                            <PositionView shapeModel={this.props.contextTarget} dispatch={this.props.dispatch}/>
                            : null
                        }
                        {this.state.selectedViewType === SELECTED_VIEW_ROTATION ?
                            <RotationView shapeModel={this.props.contextTarget} dispatch={this.props.dispatch}/>
                            : null
                        }
                        {this.state.selectedViewType === SELECTED_VIEW_SIZE ?
                            <ResizeView shapeModel={this.props.contextTarget} dispatch={this.props.dispatch}/>
                            : null
                        }
                        {this.state.selectedViewType === SELECTED_VIEW_FLIP ?
                            <FlipView shapeModel={this.props.contextTarget} dispatch={this.props.dispatch}/>
                            : null
                        }
                    </div>
                    : null
                }

                {isNonRectangular == true ?
                    <div style={wrapperStyle}>
                        <PositionViewLineAndCurve shapeModel={this.props.contextTarget} dispatch={this.props.dispatch}/>
                    </div>
                    : null
                }
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/SizeAndPositionMenu.js
 **/